// Postgres `timestamp without time zone` columns (created_at, etc.) are
// stored in UTC on this DB (server timezone is UTC) but PostgREST returns
// them with no 'Z'/offset suffix -- e.g. "2026-08-21T15:57:08.771663".
// `new Date(...)` on a timezone-less string parses it as *local* time per
// the JS spec, so code that just did `new Date(iso)` was echoing the raw
// UTC digits back as if they were already local -- silently off by the
// viewer's UTC offset (a full hour for Lisbon's summer WEST DST). Route
// every DB-timestamp parse through this instead so local getters and
// Intl.DateTimeFormat (which both convert UTC -> viewer-local correctly
// once the Date object itself represents the right instant) produce the
// actual local wall-clock time.
export function parseDbTimestamp(iso: string | null | undefined): Date | null {
  if (!iso) return null
  const hasOffset = /(Z|[+-]\d{2}:?\d{2})$/.test(iso)
  const date = new Date(hasOffset ? iso : `${iso}Z`)
  return Number.isNaN(date.getTime()) ? null : date
}
